import * as React from "react";
import { Box, Grid } from "@material-ui/core";
import { SvgIcon } from "../../../../components";
import { themeVariables } from "../../MUI";
import { tl, cssHidden } from "../../../../utils";

import * as styles from "./styles.scss";

interface IProps {
  theory: number | string;
  practice: number | string;
  disabled?: boolean;
  noDivider?: boolean;
}

export const CourseCardHours = (props: IProps) => {
  const badgeStyles = {
    bgcolor: props.disabled
      ? themeVariables.palette.grey[300]
      : themeVariables.palette.shop.main,
    color: props.disabled
      ? themeVariables.palette.common.white
      : themeVariables.palette.shop.contrastText,
  };
  const textColor = themeVariables.palette.grey[props.disabled ? 500 : 50];

  return (
    <Box pt={1.5} className={styles.cardHoursWrap}>
      <Box clone mt={-0.25} mb={-0.625} color="primary.dark">
        <Grid container wrap="nowrap">
          <Grid item xs={6} className={styles.cardHours}>
            <Box className={styles.cardHoursValues} color={textColor}>
              <Box clone mr={0.5}>
                <SvgIcon
                  type={`courses-clock ${props.disabled ? "disabled" : ""}`}
                />
              </Box>
              <Box
                px={0.5}
                pt={0.25}
                pb={0.25}
                ml={-1.25}
                {...badgeStyles}
                className={styles.cardLessonsHours}
              >
                {props.theory + tl("ч")}
              </Box>
            </Box>
            <Box color={textColor}>{tl("Теория")}</Box>
            <Box
              borderRight={themeVariables.border}
              className={styles.cardHoursBorder}
            />
          </Grid>
          <Grid item xs={6} className={styles.cardHours}>
            <Box className={styles.cardHoursValues} color={textColor}>
              <Box clone mr={0.5}>
                <SvgIcon
                  type={`courses-clock ${props.disabled ? "disabled" : ""}`}
                />
              </Box>
              <Box
                px={0.5}
                pt={0.25}
                pb={0.25}
                ml={-1.25}
                {...badgeStyles}
                className={styles.cardLessonsHours}
              >
                {props.practice + tl("ч")}
              </Box>
            </Box>
            <Box color={textColor}>{tl("Практика")}</Box>
            {props.noDivider ? null : (
              <Box
                borderRight={themeVariables.border}
                className={`${styles.cardHoursBorder}`}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
